export const ROUTES = {
    HOME: '/',
    ABOUT: '/ve-chung-toi',
    CONTACT: '/lien-he',
    FEE_SCHEDULE: '/san-pham/bieu-phi',
    AGREEMENT: '/thoa-thuan-nguoi-dung',
    CONDITION: '/dieu-khoan-va-dieu-kien',
    PRIVACY: '/quy-dinh-khieu-nai-va-hoan-tien',
    PAYMENT_GATEWAYS: '/san-pham',
    E_WALLETS: '/san-pham/vi-dien-tu',
    SERVICES: '/san-pham/thu-ho',
    NEWS: '/tin-tuc',
    SINGLE_NEWS: '/bai-viet/:id',
    NEW_CATEGORY: '/tin-tuc/:id',
    TERM: '/chinh-sach-bao-mat',
    SUPPORT_LOOKUP: '/tra-cuu-yeu-cau-ho-tro',
    SUSPICIOUS_CRITERIA: '/bo-tieu-chi-nhan-dien-dau-hieu-dang-ngo',
};